import { render } from "./TwoEqualsections.vue?vue&type=template&id=3e80af2b&scoped=true"
import script from "./TwoEqualsections.vue?vue&type=script&lang=js"
export * from "./TwoEqualsections.vue?vue&type=script&lang=js"

import "./TwoEqualsections.vue?vue&type=style&index=0&id=3e80af2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e80af2b"]])

export default __exports__